import { render, staticRenderFns } from "./BillPaymentsComponent.vue?vue&type=template&id=47000098&"
import script from "./BillPaymentsComponent.vue?vue&type=script&lang=js&"
export * from "./BillPaymentsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports